import { WorkspaceDemandProgressBar } from '@/components/ui/DemandGenProgress';
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from '@/components/ui/resizable';
import { useWorkspaceBusy } from '@/hooks/useWorkspaceBusy';
import { cn } from '@/lib/utils';
import { AgentChatWorkspace } from '@/services/types/agent-chat-workspace-types';

import { Editor } from '../demands-v2/editor/Editor';
import { TrackChangesControls } from '../demands-v2/editor/TrackChangesControls';
import { WorkspaceChat } from './workspace-chat/WorkspaceChat';

interface WorkspaceDetailProps {
  workspace: AgentChatWorkspace;
  firmId: string;
  matterId: string;
  className?: string;
}

export const WorkspaceDocument = ({
  workspace,
  matterId,
  firmId,
  className,
}: WorkspaceDetailProps) => {
  const isWorkspaceBusy = useWorkspaceBusy(matterId, workspace.id);

  return (
    <div
      className={cn('relative flex flex-col h-full w-full min-h-0', className)}
    >
      <ResizablePanelGroup
        direction="horizontal"
        className={cn('h-full w-full', className)}
      >
        <ResizablePanel defaultSize={60} minSize={40} className="relative">
          {isWorkspaceBusy && (
            <div className="absolute inset-0 z-10 bg-white/70 backdrop-blur flex flex-col items-center justify-center px-4">
              <img
                src="/progress.gif"
                alt="Generating demand"
                className="h-12 w-12 mb-2"
              />
              <WorkspaceDemandProgressBar matterId={matterId} inline />
            </div>
          )}

          <TrackChangesControls />
          <Editor
            firmId={firmId}
            key={workspace.document_id}
            matterId={matterId}
            documentId={workspace.document_id}
            workspaceId={workspace.id}
          />
        </ResizablePanel>
        <ResizableHandle withHandle className="z-0" />
        <ResizablePanel defaultSize={40} minSize={30}>
          <WorkspaceChat
            workspaceId={workspace.id}
            matterId={matterId}
            documentId={workspace.document_id}
          />
        </ResizablePanel>
      </ResizablePanelGroup>
    </div>
  );
};
